import React, { createContext } from 'react'
import { Consumer } from '../models/Consumer'
import { Item, Variant, DeliveryOption } from '../models/Item'
import { Category } from '../models/Category'
import { Country } from '../models/Country'
import { Cart, CartItem } from '../models/Cart'
import { Gift } from '../models/Gift'
import { Recipient } from '../models/Recipient'
import { OrderStatus, PaymentMethod } from '../config/enums'
import { Credit } from '../models/Credit'

export interface MigrantContextInterface {
  profile: Consumer | null
  setProfile: React.Dispatch<React.SetStateAction<Consumer | null>>
  shopCountry: Country | null
  setShopCountry: React.Dispatch<React.SetStateAction<Country | null>>
  isShoppingForSelf: boolean
  selectedCategory: Category | null
  setSelectedCategory: React.Dispatch<React.SetStateAction<Category | null>>
  cart: Cart
  addItemToCart: (
    item: Item,
    quantity: number,
    variant: Variant,
    gift?: Gift,
    months?: number
  ) => Promise<void>
  removeItemFromCart: (cartItem: CartItem) => Promise<void>
  resetCachedCart: () => void
  resyncCart: () => Promise<void>
  updateOrderRecipient: (recipient: Recipient) => Promise<void>
  updateOrderShippingInfo: (
    shippingInfo: { itemId: string; option: DeliveryOption }[],
    recipient?: Recipient
  ) => Promise<void>
  placeOrder: (paymentMethod: PaymentMethod) => Promise<void>
  updateOrderStatus: (status: OrderStatus) => void
  credits: Credit | null
}

export const MigrantContext = createContext<MigrantContextInterface | null>(
  null
)
